export default __webpack_public_path__ + "static/business-signin-84dbd3d2aebd77bdbe8514ab94212852.jpg";